import { useContext, createContext } from 'react';

export const MoodsContext = createContext(null);

export function useMoodsContext() {
  return useContext(MoodsContext);
}
